<script setup lang="ts">

import BalmDialog from '@/vue/atoms/balm-dialog.vue';
import HtmlFormatted from '@/vue/molecules/html-formatted.vue';
import {
  computed,
} from 'vue';
import {LegalModel} from '@/ts/types/component/public-sign-up-page';
import type {GetLegalDocsResponse} from '@/ts/types/dto/tos-dto';
import {useLogger} from '@/ts/composables/pure/use-logger';

const logger = useLogger();

const props = defineProps<{
  legalDocs: GetLegalDocsResponse;
}>();

const legalModel = defineModel<LegalModel | null>('legalModel', {required: true});

const dialogOpened = computed({
  get: () => Boolean(legalModel.value),
  set: (value: boolean) => {
    if (value) {
      logger.warn('Unexpected: dialogOpened setter called with true')();
      return;
    }
    legalModel.value = null;
  },
});

const modalHtml = computed(() => {
  if (!legalModel.value || !props.legalDocs) {
    return '';
  } else if (legalModel.value === LegalModel.IMPRINT) {
    return props.legalDocs!.imprint.legalCopyHTML;
  } else if (legalModel.value === LegalModel.TERMS_OF_SERVICE) {
    return props.legalDocs!.termsAndConditions.legalCopyHTML;
  } else if (legalModel.value === LegalModel.PRIVACY_POLICY) {
    return props.legalDocs!.privacyPolicy.legalCopyHTML;
  }
  logger.warn('Unknown legal model', legalModel.value)();
  return '';
});
</script>
<template>
  <balm-dialog v-model="dialogOpened" theme="neutral-0" type="fit-content">
    <div class="legal-content">
      <html-formatted :html="modalHtml" background="neutral-0"/>
    </div>
  </balm-dialog>
</template>
<style scoped lang="scss">
.legal-content {
  width: 100%;
  max-width: 680px;
  padding: var(--Spacing-spacing-6);
}
</style>
